// extracted by mini-css-extract-plugin
module.exports = {"loading_text":"Spinner_loading_text__UVGcX","over_screen":"Spinner_over_screen__14E8G"};